import axios from 'axios';
import BigNumber from 'bignumber.js';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * 获取URL中的文件后缀
 * @param {string} url 数据源的URL
 * @returns {string} 解析后的文件后缀
 */
function getSuffix(url) {
    if (!url) {
        return '';
    }
    var result = decodeURIComponent(url).match(/\.(\w+?)(?=(\?|$))/);
    return result ? result[1] : '';
}
/**
 * 获取URL中的文件名
 * @param {string} url 数据源的URL
 * @param {boolean} withExtensions 是否返回后缀名，默认为 true
 * @returns {string} 解析后的文件名
 */
function getFileName(url, withExtensions) {
    if (withExtensions === void 0) { withExtensions = true; }
    if (!url) {
        return '';
    }
    var result = decodeURIComponent(url).match(/([^/]+?)(?=(\?|$))/);
    if (!result) {
        return '';
    }
    var fileNameWithExtensions = result[1];
    return withExtensions ? fileNameWithExtensions : fileNameWithExtensions.replace(/\.[^.]+$/, '');
}
function getParams(url, key) {
    if (url === void 0) { url = location.href; }
    var params = {};
    url = decodeURIComponent(url);
    url.replace(/[?|&](\w+)=([^&^?]*)/g, function (matchStr, $1, $2) {
        params[$1] = $2;
        return matchStr;
    });
    return key ? params[key] : params;
}
/**
 * URL参数串行化 / 添加参数，并进行URL参数编码
 * @param {string} baseURL 原URL
 * @param {object} params URL参数
 * @param {boolean} isEncode 是否编码
 * @returns {string} 解析组合好的字符串
 */
function serialize(baseURL, params, isEncode) {
    var paramsStr = '';
    if (baseURL) {
        params = Object.assign({}, getParams(baseURL), params);
    }
    for (var key in params) {
        key = isEncode ? encodeURIComponent(key) : key;
        var value = isEncode ? encodeURIComponent(params[key]) : params[key];
        paramsStr += "".concat(key, "=").concat(value, "&");
    }
    paramsStr = paramsStr.slice(0, -1);
    if (baseURL) {
        var base = baseURL.split('?')[0];
        return paramsStr ? "".concat(base, "?").concat(paramsStr) : base;
    }
    else {
        return paramsStr;
    }
}
/**
 * 获取URL中的路径信息
 * @param {string} url 解析的URL
 * @returns {string} 路径字符串
 */
function getPath(url) {
    url = url || location.href;
    var elemList = url.split('/');
    elemList.shift(); // 去除http:/
    elemList.shift(); // 去除//
    elemList.shift(); // 去除域名
    return elemList.join('/');
}

/**
 * 字符串填充「0」
 * @param {string | number} origin 原始字符串
 * @param {number} length 目标字符串长度
 * @param {FillZeroOptions} options 其他参数
 * @param {boolean} [options.isFillBack=false] 是否从尾部填充，默认从头部填充
 * @param {boolean} [options.truncate=false] 超出时是否截断
 * @returns {string} 处理后的字符串
 */
function fillZero(origin, length, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isFillBack, isFillBack = _c === void 0 ? false : _c, _d = _b.truncate, truncate = _d === void 0 ? false : _d;
    var originStr = String(origin);
    if (!truncate) {
        // 若原长度比目标长度更长，且 truncate 为 false，则不截断
        length = originStr.length > length ? originStr.length : length;
    }
    if (isFillBack) {
        return (originStr + new Array(length).join('0')).substring(0, length);
    }
    else {
        return (new Array(length).join('0') + origin.toString()).slice(-length);
    }
}
/**
 * 获取随机字符串
 * @param {number} length 字符串长度
 * @param {string} [type] 随机字符串类型，letter纯字母，number纯数字，mix字母与数字混合
 * @param {string} [prefix] 字符串前缀
 * @returns {string} 生成的随机字符串
 */
function randomString(length, type, prefix) {
    if (type === void 0) { type = 'letter'; }
    if (prefix === void 0) { prefix = ''; }
    var numbers = '0123456789';
    var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var chars = '';
    var result = prefix;
    if (type === 'number' || type === 'mix') {
        chars += numbers;
    }
    if (type === 'letter' || type === 'mix') {
        chars += letters;
    }
    for (var i = 0; i < length; i++) {
        result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
}
/**
 * 除去多余参数
 * @param {AnyObj} obj 需要处理的对象
 * @param {boolean} isFillEmptyStr 是否填充为空字符串
 * @returns {object} 处理完成后的对象
 */
function deleteEmpty(obj, isFillEmptyStr) {
    if (isFillEmptyStr === void 0) { isFillEmptyStr = false; }
    obj = JSON.parse(JSON.stringify(obj));
    Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] === 'string') {
            obj[key] = obj[key].trim();
        }
        if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
            if (isFillEmptyStr) {
                obj[key] = '';
            }
            else {
                delete obj[key];
            }
        }
        if (typeof obj[key] === 'object' && obj[key].constructor !== Array) {
            obj[key] = deleteEmpty(obj[key], isFillEmptyStr);
        }
    });
    return obj;
}
/**
 * 获取img标签图片的base64数据
 * @param {HTMLImageElement} img img标签
 * @returns {string} base64数据
 */
function getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, img.width, img.height);
    return canvas.toDataURL('image/png');
}
/**
 * 将base64数据转化为file对象
 * @param {string} base64Str base64数据
 * @param {string} fileName 文件名
 * @returns {File|nerve} 文件对象
 */
function base64ToFile(base64Str, fileName) {
    var params = base64Str.split(',');
    var paramsMatch = params[0].match(/:(.*?)/);
    if (!paramsMatch) {
        throw new Error('传入的base64Str无法解析');
    }
    var mime = paramsMatch[1];
    var fileData = atob(params[1]); // 解码Base64
    var length = fileData.length;
    var uint8Array = new Uint8Array(length);
    while (length) {
        length -= 1;
        uint8Array[length] = fileData.charCodeAt(length);
    }
    return new File([uint8Array], fileName, { type: mime });
}
/**
 * 将blob数据转化为buffer对象
 * @param {Blob} blob blob对象
 * @returns {Promise<any>} promise回调
 */
function blobToBuffer(blob) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (result) {
            resolve(result);
        };
        reader.readAsArrayBuffer(blob);
    });
}
/**
 * 根据 blob 或 url 直接下载文件
 * @param {string|Blob} url 获取文件对应的URL
 * @param {string} [fileName] 文件名，仅对同源 url 生效。可以直接带后缀，这样就可以免除第三个参数
 * @param {string} [fileType] 文件类型
 */
function download(url, fileName, fileType) {
    var isBlob = url instanceof Blob;
    var targetUrl = isBlob ? URL.createObjectURL(url) : url;
    var a = document.createElement('a');
    var downloadValue = fileName ? [fileName, fileType].filter(Boolean).join('.') : '';
    downloadValue && (a.download = downloadValue);
    a.href = targetUrl;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.parentNode && a.parentNode.removeChild(a);
    if (isBlob) {
        URL.revokeObjectURL(targetUrl);
    }
}
/**
 * 文件下载
 * @param {string} url 获取文件对应的URL
 * @param {object} data 文件内容
 * @param {string} [fileName] 文件名，仅对同源 url 生效。可以直接带后缀，这样就可以免除第三个参数
 * @param {string} [fileType] 文件类型
 */
function downloadFile(url, data, fileName, fileType) {
    if (data === void 0) { data = {}; }
    fileName = fileName || getFileName(url);
    fileType = fileType || getSuffix(url);
    data = Object.assign({}, data, { token: localStorage.getItem('token') });
    axios({
        url: url,
        method: 'get',
        responseType: 'blob',
        params: data
    }).then(function (res) {
        var fileBlob = new Blob([res.data]); // 创建一个Blob对象
        download(fileBlob, fileName, fileType);
    });
}
/**
 * 获取完整的URL绝对，解决相对路径转变为绝对路径的问题
 * @param {string} path 原路径
 * @returns {string} 解析后的路径
 */
function getURL(path) {
    var $a = document.createElement('a');
    $a.href = path;
    return $a.href;
}
/**
 * 获取阿里OSS云存储的图片裁剪功能后的图片，减少图片体积，节约流量
 * @param {string} url 图片URL
 * @param {number} width 图片宽度 / 短边长度
 * @param {number} [height] 图片高度
 * @param {string} [type] 图片缩放方式，默认m_fill为自动裁剪，m_mfit，短边优先，长边自动扩充。详情参考https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.4.1.rGBEsn
 * @returns {string} 处理后的图片链接
 */
function getFitURL(url, width, height, type) {
    if (type === void 0) { type = 'm_fill'; }
    height = height || width;
    return url
        ? serialize(url, {
            'x-oss-process': "image/resize,".concat(type, ",h_").concat(parseInt(height.toString()), ",w_").concat(parseInt(width.toString()))
        }, false)
        : '';
}
/**
 * 获取首字母大写的字符串
 * @param {string} text 待替换字符串
 * @returns {string} 转化后的字符串
 */
function getWord(text) {
    return text[0].toUpperCase() + text.slice(1);
}
/**
 * 将横线命名转化为驼峰命名法
 * @param {string} text 待替换字符串
 * @param {string} char 单词间隔符
 * @returns {string} 转化后的字符串
 */
function getCamelCase(text, char) {
    if (char === void 0) { char = '-'; }
    var reg = new RegExp("".concat(char, "([a-z]|[0-9])+?"), 'g');
    return text.replace(reg, function (matchStr) { return matchStr[1].toUpperCase(); });
}
/**
 * 将驼峰命名法转化为横线命名
 * @param {string} text 待替换字符串
 * @param {string} char 单词间隔符
 * @returns {string} 转化后的字符串
 */
function getUnderScoreCase(text, char) {
    if (char === void 0) { char = '-'; }
    return text.replace(/[A-Z]+?/g, function (matchStr) { return "".concat(char).concat(matchStr.toLowerCase()); });
}
/**
 * 获取符合条件的所有对象
 * @param {Array<AnyObj>} list 候选数组
 * @param {AnyObj} condition 对象特征
 * @returns {Array}符合的对象数组
 */
function getMatchObjList(list, condition) {
    var matchList = [];
    list.forEach(function (item, index) {
        for (var key in condition) {
            if (condition[key] !== item[key]) {
                return;
            }
        }
        matchList.push({
            index: index,
            content: item
        });
    });
    return matchList;
}
/**
 * 获取符合条件的对象索引
 * @param {Array<AnyObj>} list 候选数组
 * @param {AnyObj} condition 对象特征
 * @returns {number} 符合条件的对象索引
 */
function getMatchObjIndex(list, condition) {
    var result = getMatchObjList(list, condition);
    return result.length > 0 ? result[0].index : -1;
}
/**
 * 获取符合条件的对象
 * @param {Array<AnyObj>} list 候选数组
 * @param {AnyObj} condition 对象特征
 * @returns {object} 符合条件的对象
 */
function getMatchObj(list, condition) {
    return (getMatchObjList(list, condition)[0] || {}).content;
}
/**
 * 解析对象字符串
 * @param {AnyObj} targetObj 目标对象
 * @param {string} str 字符串表达式
 * @param {string} splitWord 字符串表达式分隔符
 * @returns {object} 符合条件的对象
 */
function parseObjStr(targetObj, str, splitWord) {
    if (splitWord === void 0) { splitWord = '.'; }
    return str.split(splitWord).reduce(function (obj, key) { return obj[key]; }, targetObj);
}
/**
 * 格式化大小
 * @param {number} value 文件大小(单位为Bytes)
 * @param {number} decimals 保留的小数位
 * @returns {string} 文件大小字符串
 */
function formatSize(value, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (value) {
        // eslint-disable-next-line no-magic-numbers
        var index = Math.floor(Math.log(value) / Math.log(1024));
        // eslint-disable-next-line no-magic-numbers
        var size = Number((value / Math.pow(1024, index)).toFixed(decimals));
        return (size + ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][index]);
    }
    return '0 Bytes';
}
/**
 * 替换对象的key
 * @param {object} target 目标对象
 * @param {object} keyMap key值转换映射，如将a转化为b，则{a:b}
 * @returns {any} 转化后的对象
 */
function changeObjKey(target, keyMap) {
    var targetObj = JSON.stringify(target);
    for (var key in keyMap) {
        targetObj = targetObj.replace(new RegExp("\"".concat(key, "\":"), 'g'), "\"".concat(keyMap[key], "\":"));
    }
    return JSON.parse(targetObj);
}
/**
 * 防抖
 * @param {Function} func 回调函数
 * @param {number} waitTime 防抖时间(毫秒)
 * @param {boolean} firstIsDebounce 第一次是否防抖，默认true
 * @returns {Function} 转换后的函数
 */
var defaultWaitTime = 300; // 默认防抖时间（ms）
function debounce(func, waitTime, firstIsDebounce) {
    if (waitTime === void 0) { waitTime = defaultWaitTime; }
    if (firstIsDebounce === void 0) { firstIsDebounce = true; }
    var timeout;
    return function () {
        var arguments$1 = arguments;

        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments$1[_i];
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        if (firstIsDebounce) {
            timeout = setTimeout(function () {
                func.apply(void 0, args);
            }, waitTime);
        }
        else {
            func.apply(void 0, args);
            firstIsDebounce = true;
        }
    };
}
/**
 * 比较数字大小补0
 * @example
 * // 返回 '05'
 * compareFillZero(5)
 * @example
 * // 返回 '025'
 * compareFillZero(25,1000)
 * @param {number|string} num 数字
 * @param {number|string} maxNum 比较的数字
 * @param {string} fillUnit 默认0，可其他字符串*，-等
 * @returns {string} 补0后的字符串
 */
function compareFillZero(num, maxNum, fillUnit) {
    if (maxNum === void 0) { maxNum = 100; }
    if (fillUnit === void 0) { fillUnit = '0'; }
    if (!num && +num !== 0) {
        return '';
    }
    var numString = "".concat(num);
    if (+num < +maxNum) {
        for (var i = 1; i < String(maxNum).length - String(num).length; i++) {
            numString = fillUnit + numString;
        }
    }
    return numString;
}
/**
 * 传入数据,返回该数据的数据类型
 * *用例: dataType(null) 'null'
 * *用例: dataType({}) => 'object'
 * @param {any} data 任何的数据
 * @returns {string} 该数据的数据类型
 */
function dataType(data) {
    if (data instanceof Element) {
        return 'element';
    }
    var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Object]': 'object',
        '[object Null]': 'null',
        '[object Undefined]': 'undefined',
        '[object RegExp]': 'regExp',
        '[object Date]': 'date',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Math]': 'math',
        '[object Symbol]': 'symbol',
        '[object Error]': 'error'
    };
    var res = map[Object.prototype.toString.call(data)];
    if (res === 'number' && data !== data) {
        res = 'NaN';
    }
    return res;
}
/**
 * 判断是否为非空值（null undefined ''）
 * *用例: isNotVoid(null) false
 * *用例: isNotVoid(undefined) => false
 * *用例: isNotVoid(0) => false
 * *用例: isNotVoid(0,false) => true
 * *用例: isNotVoid('') => false
 * @param {any} data 任何的数据
 * @param {boolean} isIncludeZero 是否需要判断0
 * @returns {boolean} 该数据是否空值
 */
function isNotVoid(data, isIncludeZero) {
    if (isIncludeZero === void 0) { isIncludeZero = true; }
    if (isIncludeZero) {
        return !!data;
    }
    else {
        return (data === 0 || !!data);
    }
}
/**
 * url参数对象转为拼接好的字符串
 * *用例: paramObjToQueryString({ orderNo: 123, id: 1 }) => ?orderNo=123&id=1
 * @param {AnyObj} paramObj url参数对象
 * @returns {string} queryStr 拼接好的字符串
 */
function paramObjToQueryString(paramObj) {
    var queryStr = '';
    Object.entries(paramObj).forEach(function (item) {
        if (queryStr[0] !== '?') {
            queryStr = "?".concat(item[0], "=").concat(item[1]);
        }
        else {
            queryStr = "".concat(queryStr, "&").concat(item[0], "=").concat(item[1]);
        }
    });
    return queryStr;
}
/**
 * 打开新窗口
 * @param {string|Function} val 传入的是url字符串，或者是异步函数(返回 url)
 */
function openWindow(val) {
    return __awaiter(this, void 0, void 0, function () {
        var win, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    win = window.open('', '_blank');
                    url = '';
                    if (!(typeof val === 'string')) { return [3 /*break*/, 1]; }
                    url = val;
                    win && (win.location.href = url);
                    return [3 /*break*/, 6];
                case 1:
                    if (!(Object.prototype.toString.call(val) === '[object Function]' || Object.prototype.toString.call(val) === '[object AsyncFunction]')) { return [3 /*break*/, 6]; }
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    url = val();
                    if (!(url && typeof url.then === 'function')) { return [3 /*break*/, 4]; }
                    return [4 /*yield*/, url];
                case 3:
                    url = _a.sent();
                    _a.label = 4;
                case 4:
                    win && (win.location.href = url);
                    return [3 /*break*/, 6];
                case 5:
                    _a.sent();
                    win && win.close();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}

/* eslint-disable no-magic-numbers */
function dealTime(time, type) {
    if (type === void 0) { type = 'string'; }
    if (!time) {
        return type === 'string' ? '' : null;
    }
    if (time.toString().indexOf('/') > 0 || time.toString().indexOf('-') > 0) {
        time = new Date(time);
    }
    else if (typeof time === 'string' || typeof time === 'number') {
        var standTimeStampLength = 13; // 标准时间戳长度
        time = fillZero(time, standTimeStampLength, { isFillBack: true }); // 转化为标准的13位时间戳
        time = new Date(parseInt(time));
    }
    if (type === 'object') {
        return time;
    }
    else {
        return time.getTime();
    }
}
/**
 * 格式化时间
 * @param {string|number|Date} date 时间内容，可传入时间对象，或时间戳
 * @param {string} formatStr 格式模板
 * @returns {string} 处理后的字符串
 */
function formatTime(date, formatStr) {
    if (formatStr === void 0) { formatStr = 'YYYY-MM-DD hh:mm:ss'; }
    if (!date) {
        return '';
    }
    date = dealTime(date, 'object');
    var formatType = {
        Y: date.getFullYear(),
        M: date.getMonth() + 1,
        D: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds(),
    };
    return formatStr.replace(/Y+|M+|D+|h+|m+|s+/g, function (target) { return fillZero(formatType[target[0]], target.length, { truncate: true }); });
}
/**
 * 判断给出的时间是否已经过期
 * @param {string|number|Date} timestamp 给出的时间戳或时间对象
 * @returns {boolean} 是否过期
 */
function isOverdue(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    return timestamp < new Date().getTime();
}
/**
 * 获取最近几天的时间范围
 * @param {number} length 天数，最近的几天
 * @param {string|number|Date} [date] 截止时间，默认为今天
 * @returns {[number, number]} 解析好之后的时间戳范围数组
 */
function getLastSomeDay(length, date) {
    if (date === void 0) { date = new Date(); }
    date = dealTime(date, 'object');
    var startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate() - length);
    var endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, -1);
    return [startTime.getTime(), endTime.getTime()];
}
/**
 * 获取某月的时间戳范围
 * @param {string|number|Date} date 特定格式化的时间
 * @returns {[number, number]} 解析好之后的时间戳范围
 */
function getMonthRange(date) {
    if (date === void 0) { date = new Date(); }
    date = dealTime(date, 'object');
    var startTime = new Date(date.getFullYear(), date.getMonth(), 1);
    var endTime = new Date(date.getFullYear(), date.getMonth() + 1, 1, 0, 0, -1);
    return [startTime.getTime(), endTime.getTime()];
}
/**
 * 获取某周的时间戳范围
 * @param {string|number|Date} date 特定格式化的时间
 * @returns {[number, number]} 解析好之后的时间戳范围
 */
function getWeekRange(date) {
    if (date === void 0) { date = new Date(); }
    date = dealTime(date, 'object');
    var daysInWeek = 7;
    var day = date.getDay();
    // Date.prototype.getDay() 的返回值为 0-6，0 表示周日
    var week = day === 0 ? 6 : day - 1;
    var startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate() - week);
    var endTime = new Date(date.getFullYear(), date.getMonth(), (daysInWeek - week) + date.getDate(), 0, 0, -1);
    return [startTime.getTime(), endTime.getTime()];
}
/**
 * 获取某日的时间戳范围
 * @param {string|number|Date} [date] 特定格式化的时间
 * @returns {[number, number]} 解析好之后的时间戳范围
 */
function getDayRange(date) {
    if (date === void 0) { date = new Date(); }
    date = dealTime(date, 'object');
    var startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, -1);
    return [startTime.getTime(), endTime.getTime()];
}
/**
 * 获取时间提示信息
 * @param {string|number|Date} timestamp 需要转换的时间戳
 * @returns {string} 解析好之后时间提示
 */
function getDateTips(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    var date = new Date();
    var now = date.getTime();
    var fiveMinuteBefore = new Date().setMinutes(date.getMinutes() - 5);
    var oneHourBefore = new Date().setHours(date.getHours() - 1);
    var today = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    var yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1).getTime();
    var twoDaysBefore = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2).getTime();
    if (timestamp > fiveMinuteBefore) { // 5分钟内
        return '刚刚';
    }
    else if (timestamp > oneHourBefore) { // 60分钟内
        return "".concat(Math.floor((now - timestamp) / 1000 / 60), "\u5206\u949F\u524D");
    }
    else if (timestamp > today) { // 今天
        return "\u4ECA\u5929 ".concat(formatTime(timestamp, 'hh时mm分'));
    }
    else if (timestamp > yesterday) { // 昨天
        return "\u6628\u5929 ".concat(formatTime(timestamp, 'hh时mm分'));
    }
    else if (timestamp > twoDaysBefore) { // 前天
        return "\u524D\u5929 ".concat(formatTime(timestamp, 'hh时mm分'));
    }
    else { // 更久之前
        return formatTime(timestamp, 'MM月DD日 hh时mm分');
    }
}
/**
 * 是否是今天
 * @param {string|number|Date} timestamp 给出的时间戳或时间对象
 * @returns {boolean} 是否是今天
 */
function isToday(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    var date = new Date();
    var timeStart = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    var timeEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).getTime();
    return timeStart <= timestamp && timestamp < timeEnd;
}
/**
 * 是否是明天
 * @param {string|number|Date} timestamp 给出的时间戳或时间对象
 * @returns {boolean} 是否是明天
 */
function isTomorrow(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    var date = new Date();
    var timeStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).getTime();
    var timeEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2).getTime();
    return timeStart <= timestamp && timestamp < timeEnd;
}
/**
 * 是否是后天
 * @param {string|number|Date} timestamp 给出的时间戳或时间对象
 * @returns {boolean} 是否是后天
 */
function isTheDayAfterTomorrow(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    var date = new Date();
    var timeStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2).getTime();
    var timeEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3).getTime();
    return timeStart <= timestamp && timestamp < timeEnd;
}
/**
 * 是否是昨天
 * @param {string|number|Date} timestamp 给出的时间戳或时间对象
 * @returns {boolean} 是否是昨天
 */
function isYesterday(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    var date = new Date();
    var timeStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1).getTime();
    var timeEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    return timeStart <= timestamp && timestamp < timeEnd;
}
/**
 * 是否是前天
 * @param {string|number|Date} timestamp 给出的时间戳或时间对象
 * @returns {boolean} 是否是前天
 */
function isTheDayBeforeYesterday(timestamp) {
    timestamp = dealTime(timestamp, 'string');
    var date = new Date();
    var timeStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2).getTime();
    var timeEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1).getTime();
    return timeStart <= timestamp && timestamp < timeEnd;
}
/**
 * 获取日期对应的星期数
 * @param {string|number|Date} date 给出的时间戳或时间对象
 * @returns {string} 日期
 */
function getWeek(date) {
    date = dealTime(date, 'object');
    return ['日', '一', '二', '三', '四', '五', '六'][date.getDay()];
}
/**
 * 是否在同一个时间段内
 * @param {string|number|Date} time1 时间1
 * @param {string|number|Date} time2 时间2
 * @param {'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'} timeType 时间段类型
 * @returns {boolean} 是否在同一个时间段内
 */
function isSame(time1, time2, timeType) {
    var formatObj = {
        year: 'YYYY',
        month: 'YYYY:MM',
        day: 'YYYY:MM:DD',
        hour: 'YYYY:MM:DD hh',
        minute: 'YYYY:MM:DD hh:mm',
        second: 'YYYY:MM:DD hh:mm:ss',
    };
    var formatStr = formatObj[timeType];
    return formatTime(time1, formatStr) === formatTime(time2, formatStr);
}
/**
 * 转化时间长度
 * @param {string|number} time 时间长度
 * @param {'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'} type 转换类型
 * @returns {number} 转换后的数值
 */
function getTimeLength(time, type) {
    if (typeof time === 'string') {
        time = parseInt(time);
    }
    var timeStampObj = {
        year: 365 * 24 * 60 * 60 * 1000,
        month: 30 * 24 * 60 * 60 * 1000,
        day: 24 * 60 * 60 * 1000,
        hour: 60 * 60 * 1000,
        minute: 60 * 1000,
        second: 1000,
    };
    return time / timeStampObj[type];
}
/**
 * 获取当前月共有多少天
 * @param {string | number | Date} date 日期对象
 * @returns {number} 当前月的天数
 */
function getMonthDays(date) {
    if (date === void 0) { date = new Date(); }
    var dateString = dealTime(date, 'object').toISOString();
    var clonedDate = new Date(dateString);
    clonedDate.setDate(1);
    clonedDate.setMonth(clonedDate.getMonth() + 1);
    clonedDate.setDate(0);
    return clonedDate.getDate();
}
/**
 * 获取多少个月后的今天
 * @param {string | number | Date} date 当前日期
 * @param {number} months 月数，表示多少个月后
 * @returns {Date} 多少个月后的今天
 */
function afterMonths(date, months) {
    var dateString = dealTime(date, 'object').toISOString();
    date = new Date(dateString); // 防止直接修改外部传进来的 Date 对象
    var dayOfMonth = date.getDate();
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    var newDayOfMonth = Math.min(dayOfMonth, getMonthDays(date));
    date.setDate(newDayOfMonth);
    return date;
}
/**
 * 时间距离，相距多少天
 * @param {string|number|Date} time1 时间1
 * @param {string|number|Date} time2 时间2
 * @param {'day' | 'hour' | 'minute' | 'second'} timeType 时间段类型
 * @returns {number} 时间距离
 */
function getDateSpace(time1, time2, timeType) {
    if (timeType === void 0) { timeType = 'day'; }
    var formatObj = {
        day: 'YYYY/MM/DD',
        hour: 'YYYY/MM/DD hh:00',
        minute: 'YYYY/MM/DD hh:mm',
        second: 'YYYY/MM/DD hh:mm:ss',
    };
    var formatStr = formatObj[timeType];
    time1 = new Date(formatTime(time1, formatStr));
    time2 = new Date(formatTime(time2, formatStr));
    return getTimeLength(time1.getTime() - time2.getTime(), timeType);
}
/**
 * 毫秒转时间 formatDuration(34325055574); // '397天,6小时,44分钟,15秒
 * @param {string|number} ms 时间(毫秒)
 * @param {string} unit 时间间隔符号 , -
 * @param {'zh'|'en'} lang 时间单位语言
 * @returns {string} 时间段
 */
function formatDuration(ms, unit, lang) {
    var _a;
    if (unit === void 0) { unit = ''; }
    if (lang === void 0) { lang = 'zh'; }
    if (typeof ms === 'string') {
        ms = parseInt(ms);
    }
    if (ms < 0) {
        ms = -ms;
    }
    var langMap = {
        day: {
            zh: '天',
            en: 'day',
        },
        hour: {
            zh: '时',
            en: 'hour',
        },
        minute: {
            zh: '分',
            en: 'minute',
        },
        second: {
            zh: '秒',
            en: 'second',
        },
        millisecond: {
            zh: '毫秒',
            en: 'millisecond',
        },
    };
    var time = (_a = {},
        _a[langMap.day[lang]] = Math.floor(ms / 86400000),
        _a[langMap.hour[lang]] = Math.floor(ms / 3600000) % 24,
        _a[langMap.minute[lang]] = Math.floor(ms / 60000) % 60,
        _a[langMap.second[lang]] = Math.floor(ms / 1000) % 60,
        _a);
    return Object.entries(time)
        .filter(function (val) {
        var isSecond = val[0] === langMap.second[lang];
        var isMin = val[0] === langMap.minute[lang];
        // 保留0秒的情况
        if (val[1] !== 0 || isSecond) {
            return val;
        }
        // 保留0分的情况
        if (val[1] !== 0 || isMin) {
            return val;
        }
        return false;
    })
        .map(function (_a) {
        var key = _a[0], val = _a[1];
        return "".concat(compareFillZero(val)).concat(key).concat((val !== 1 && lang === 'en') ? 's' : '');
    })
        .join(unit);
}
/**
 * 格式化倒计时 大于一天显示“1天”，小于一天的显示'23:00:00'格式
 * @param {string|number} ms 时间(毫秒)
 * @param {string} showFormat 显示格式，number: 12:12:10, chinese: 12时12分12秒
 * @returns {string} 时间段
 */
function formatCountDown(ms, showFormat) {
    if (showFormat === void 0) { showFormat = 'number'; }
    if (typeof ms === 'string') {
        ms = parseInt(ms);
    }
    if (ms < 0) {
        ms = -ms;
    }
    var oneDayTime = 8.64e7; // 一天的时间毫秒
    if (ms > oneDayTime) {
        // 向下取整，24小时~48小时内都算1天
        return "".concat(Math.floor(ms / oneDayTime), "\u5929");
    }
    else {
        var hour = Math.floor(ms / 3600000);
        var minute = Math.floor(ms / 60000) % 60;
        var second = Math.floor(ms / 1000) % 60;
        hour = hour < 10 ? "0".concat(hour) : hour;
        minute = minute < 10 ? "0".concat(minute) : minute;
        second = second < 10 ? "0".concat(second) : second;
        return showFormat === 'number' ? "".concat(hour, ":").concat(minute, ":").concat(second) : "".concat(hour, " \u65F6 ").concat(minute, " \u5206 ").concat(second, " \u79D2");
    }
}
/**
 * 判断time是否在时间范围（时分）内
 * @param {String}time time 判断的时间戳
 * @param {[String,String]} 时间区间数组 beginTime 开始时间 19:40 endTime 结束时间 23:59 （当天） | 08:00 （次日）
 * @returns  {Boolean} 是否再
 */
function inTimeRange(time, _a) {
    var beginTime = _a[0], endTime = _a[1];
    var strb = beginTime.split(':');
    if (strb.length !== 2) {
        return false;
    }
    var stre = endTime.split(':');
    if (stre.length !== 2) {
        return false;
    }
    var b = new Date(time);
    var e = new Date(time);
    var n = new Date(time);
    // 开始时间
    b.setHours(parseInt(strb[0]));
    b.setMinutes(parseInt(strb[1]));
    b.setSeconds(0);
    // 结束时间
    e.setHours(parseInt(stre[0]));
    e.setMinutes(parseInt(stre[1]));
    e.setSeconds(0);
    return b.getTime() < e.getTime()
        ? n.getTime() > b.getTime() && n.getTime() < e.getTime() // 开始 < 结束，取区间之内
        : n.getTime() > b.getTime() || n.getTime() < e.getTime(); // 开始 > 结束，取区间之外
}

/* eslint-disable no-magic-numbers */
/**
 * 获取小数位数
 * @param {number} number 数值
 * @returns {number} 小数位数
 */
var getDecimalsLength = function (number) {
    var matched = String(number || 0).match(/\.(\d+)$/);
    return matched ? matched[1].length : 0;
};
/**
 * 格式化数字，每隔三位添加逗号
 * @param {number} num 数值
 * @returns {string} 格式化后的数值字符串
 */
function parseNum(num) {
    var numberString = (num || 0).toString();
    // 在转换一些以万为单位的金额时，小数点位数会超过3位，小数点中的数字暂不解析
    var decimalPointIndex = numberString.indexOf('.');
    var intString = decimalPointIndex > -1 ? numberString.slice(0, decimalPointIndex) : numberString;
    var decimalString = decimalPointIndex > -1 ? numberString.slice(decimalPointIndex) : '';
    return intString.replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,') + decimalString;
}
/**
 * 保留若干位小数
 * @param {number|string} number 数值
 * @param {modeType} [mode=floor] 舍入模式，floor 是向下取整，round 是四舍五入，ceil 是向上进一位
 * @param {number} [decimals=2] 需要保留几位小数，默认 2
 * @returns {number} 保留后数值
 */
var keep2Decimals = function (number, mode, decimals) {
    if (mode === void 0) { mode = 'floor'; }
    if (decimals === void 0) { decimals = 2; }
    // eslint-disable-next-line no-magic-numbers
    var times = Math.pow(10, decimals);
    var oneHundredTimes = new BigNumber(number).times(times);
    // https://mikemcl.github.io/bignumber.js/#constructor-properties
    var roundModes = {
        ceil: BigNumber.ROUND_CEIL,
        floor: BigNumber.ROUND_FLOOR,
        round: BigNumber.ROUND_HALF_UP, // 四舍五入
    };
    var roundMode = roundModes[mode];
    if (!Object.prototype.hasOwnProperty.call(roundModes, mode)) {
        throw new Error("\u6682\u4E0D\u652F\u6301 ".concat(mode, " \u820D\u5165\u6A21\u5F0F"));
    }
    var integer = oneHundredTimes.integerValue(roundMode);
    var newNumber = new BigNumber(integer).dividedBy(times);
    return newNumber.toNumber();
};
function yuan2wan(price, digits, parseNumber) {
    if (digits === void 0) { digits = 6; }
    if (parseNumber === void 0) { parseNumber = false; }
    var bigNumber = new BigNumber(price);
    if (digits === 4) {
        bigNumber = new BigNumber(bigNumber.integerValue(BigNumber.ROUND_FLOOR));
    }
    else if (digits === 6 && getDecimalsLength(Number(bigNumber)) > 2) {
        bigNumber = new BigNumber(keep2Decimals(Number(bigNumber)));
    }
    var result = bigNumber.dividedBy(1e4).toNumber();
    if (!parseNumber) {
        return result;
    }
    return parseNum(result);
}
/**
 * 将万为单位的金额转为以元为单位
 * @param {number} price 金额
 * @param {boolean} parseNumber 是否格式化数字，每隔三位添加逗号
 * @returns {number|string} 转换后金额
 */
function wan2yuan(price, parseNumber) {
    if (parseNumber === void 0) { parseNumber = false; }
    var bigNumber = new BigNumber(price);
    var result = bigNumber.times(1e4).toNumber();
    return parseNumber ? parseNum(result) : result;
}
/**
 * 将元为单位的金额转为以分为单位
 * @param {number} price 金额
 * @param {boolean} parseNumber 是否格式化数字，每隔三位添加逗号
 * @returns {number|string} 转换后金额
 */
function yuan2fen(price, parseNumber) {
    if (parseNumber === void 0) { parseNumber = false; }
    var bigNumber = new BigNumber(price);
    var result = bigNumber.times(1e2).toNumber();
    return parseNumber ? parseNum(result) : result;
}

/* eslint-disable no-magic-numbers */
/**
 * 添加class
 * @param {HTMLElement} dom dom节点
 * @param {string} className class名
*/
function addClass(dom, className) {
    if (dom.classList) {
        dom.classList.add(className);
    }
    else {
        dom.className += " ".concat(className);
    }
}
/**
 * 移除class
 * @param {HTMLElement} dom dom节点
 * @param {string} className class名
*/
function removeClass(dom, className) {
    if (dom.classList) {
        dom.classList.remove(className);
    }
    else {
        dom.className = dom.className.replace(new RegExp("(^|\\b)".concat(className.split(' ').join('|'), "(\\b|$)"), 'gi'), ' ');
    }
}
/**
 * 判断某个 dom 上层是否存在一个符合 parentSelector 选择器的节点
 * @param {HTMLElement} dom dom 节点
 * @param {string | HTMLElement} parentSelectorOrDom 父节点选择器
 * @returns {boolean} 是否属于某个选择器对应的节点
 */
function isContainIn(dom, parentSelectorOrDom) {
    var parent = dom && dom.parentElement;
    if (!parent) {
        return false;
    }
    else if (typeof parentSelectorOrDom === 'string' ? parent.matches(parentSelectorOrDom) : parent === parentSelectorOrDom) {
        return true;
    }
    else {
        return isContainIn(parent, parentSelectorOrDom);
    }
}
/**
 * 获取css属性值
 * @param {HTMLElement} dom dom节点
 * @param {string|number} style 需要获取的dom对象的属性的值
 * @returns {string} 返回当前相关需要获取的css值
*/
function getStyle(dom, style) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.getComputedStyle(dom, null)[style];
}
/**
 * 获取dom元素绝对位置的横坐标
 * @param {object} dom dom节点
 * @returns {number} 返回横坐标
*/
function getElementLeft(element) {
    var actualLeft = element.offsetLeft;
    var current = element.offsetParent;
    while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
    }
    return actualLeft;
}
/**
 * 获取dom元素绝对位置的纵坐标
 * @param {object} dom dom节点
 * @returns {number} 返回纵坐标
*/
function getElementTop(element) {
    var actualTop = element.offsetTop;
    var current = element.offsetParent;
    while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }
    return actualTop;
}
// 获取当前距离顶部的滚动值
function getScrollTop() {
    var scrollTop = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
        // eslint-disable-next-line prefer-destructuring
        scrollTop = document.documentElement.scrollTop;
    }
    else if (document.body) {
        // eslint-disable-next-line prefer-destructuring
        scrollTop = document.body.scrollTop;
    }
    return scrollTop;
}
/**
 * 封装一个回到底部或者顶部的函数
 * @param {object} dom dom节点
 * @param {number} position 距离顶部的距离 0表示顶部
 * @param {number} scrollTopDistance 当前元素滚动的距离
*/
function smoothScroll(dom, position, scrollTopDistance) {
    // 如果你要滚到顶部，那么position传过来的就是0，下面这个distance肯定就是负值。
    var distance = position - scrollTopDistance;
    // 每次滚动的距离要不一样，制造一个缓冲效果
    scrollTopDistance = scrollTopDistance + distance / 5;
    // 判断条件
    if (Math.abs(distance) < 1) {
        dom.scrollTo({
            left: 0,
            top: position
        });
    }
    else {
        dom.scrollTo({
            left: 0,
            top: scrollTopDistance
        });
        window.requestAnimationFrame(function () { return smoothScroll(dom, position, scrollTopDistance); });
    }
}
/**
 * 封装一个回到底部或者顶部的函数
 * @param {object} dom dom节点
 * @param {string} distance 距离底部的距离 0表示底部
*/
function scrollToTop(dom, distance) {
    var position = dom.offsetHeight - distance;
    // 使用requestAnimationFrame，如果没有则使用setTimeOut
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback) {
            return setTimeout(callback, 20);
        };
    }
    // 获取当前元素滚动的距离
    var scrollTopDistance = document.documentElement.scrollTop || document.body.scrollTop;
    smoothScroll(dom, position, scrollTopDistance);
}

/* eslint-disable no-magic-numbers */
/**
 * isPhone 手机号检测
 * @param {number | string} text 待检测字符串
 * @returns {boolean} 是否手机号
 */
function isPhone(text) {
    return /^1[3-9]\d{9}$/.test(text.toString().trim());
}
/**
 * isMoney 金钱检测
 * @param {string | number} text 待检测字符串
 * @returns {boolean} 是否金钱
 */
function isMoney(text) {
    return /^(\d+\.)?\d+$/.test(text.toString().trim());
}
/**
 * isPassword 密码检测（包含数字和字母，8位以上）
 * @param {string} text 待检测字符串
 * @returns {boolean} 是否密码
 */
function isPassword(text) {
    return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(text.toString().trim());
}
/**
  * 校验身份证号码（只支持18位）
  * @param  {String}   IDNumber  待校验的身份证号码字符串
  * @return {Boolean}            校验结果，合法为 true，反之则为 false
  */
function validateIDNumber(IDNumber) {
    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
    };
    // 截取身份证的出生日期
    var birthday = "".concat(IDNumber.substr(6, 4), "/").concat(Number(IDNumber.substr(10, 2)), "/").concat(Number(IDNumber.substr(12, 2)));
    var d = new Date(birthday);
    var newBirthday = "".concat(d.getFullYear(), "/").concat(Number(d.getMonth() + 1), "/").concat(Number(d.getDate()));
    var currentTime = new Date().getTime();
    var time = d.getTime();
    var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    if (!/^\d{17}(\d|x)$/i.test(IDNumber)) {
        return false;
    }
    if (city[IDNumber.substr(0, 2)] === undefined) {
        return false;
    }
    if (time >= currentTime || birthday !== newBirthday) {
        return false;
    }
    var sum = 0;
    for (var i = 0; i < 17; i++) {
        sum = sum + Number(IDNumber.substr(i, 1)) * arrInt[i];
    }
    var residue = arrCh[sum % 11];
    if (residue !== IDNumber.substr(17, 1).toUpperCase()) {
        return false;
    }
    return true;
}
/**
 * 校验电子邮件地址是否合法
 * @param  {String}   email   待校验的电子邮件地址
 * @return {Boolean}          校验结果，合法为 true，反之则为 false
 */
function validateEmail(email) {
    if (!email) {
        return false;
    }
    // eslint-disable-next-line no-magic-numbers
    var isAscii = function (str) { return str.split('').every(function (x) { return x.charCodeAt(0) <= 127; }); };
    var reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return isAscii(email) && reg.test(String(email).toLowerCase());
}

/** 是否在服务器端 */
var isServer = typeof window === 'undefined';
var _a = (isServer ? {} : window.navigator).userAgent, userAgent = _a === void 0 ? '' : _a;
/**
 * 是否在微信内
 * @property isInWeChat
 * @type {Boolean}
 */
var isInWeChat = /\bMicroMessenger\b/.test(userAgent);
/**
 * 是否在QQ或iPad QQ内
 * @property isInQQ
 * @type {Boolean}
 */
var isInQQ = /\b(IPad)?QQ\b/.test(userAgent);
/**
 * 是否在QQ浏览器内
 * @property isInQQBrowser
 * @type {Boolean}
 */
var isInQQBrowser = /\bMQQBrowser\b/.test(userAgent);
/**
 * 是否在微博内
 * @property isInWeibo
 * @type {Boolean}
 */
var isInWeibo = /\bWeibo\b/.test(userAgent);
/**
 * 是否在小米浏览器内
 * @property isMiBrowser
 * @type {Boolean}
 */
var isMiBrowser = /\bmiuibrowser\b/i.test(userAgent);
/**
 * 是否在华为浏览器内
 * @property isHuaweiBrowser
 * @type {Boolean}
 */
var isHuaweiBrowser = /\bhuaweibrowser\b/i.test(userAgent);
/**
 * 是否在非浏览器的APP内（目前只能判断一部分APP）
 * @property isInApp
 * @type {Boolean}
 */
var isInApp = isInWeChat || isInQQ || isInWeibo;
/**
 * 是否在iOS设备下
 * @property isIOS
 * @type {Boolean}
 */
var isIOS = /\b(?:iPad|iPod|iPhone)\b/.test(userAgent)
    && /\bOS(?:\s([\d_.]+))?\slike\sMac\sOS\sX\b/.test(userAgent);
/**
 * 是否在Android设备下
 * @property isAndroid
 * @type {Boolean}
 */
var isAndroid = /\b(?:Android|Adr|YunOS)\b/.test(userAgent) || isMiBrowser || isHuaweiBrowser;
/**
 * 是否移动端
 * @type {Boolean}
 */
var isMobile = isAndroid || isIOS;
// 判断当前浏览类型
function getBrowserType() {
    if (!isServer && (window.ActiveXObject || 'ActiveXObject' in window)) { // IE
        var reIE = new RegExp('MSIE (\\d+\\.\\d+)');
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp.$1);
        return "IE".concat(fIEVersion || '低版本');
    }
    else if (userAgent.indexOf('Firefox') !== -1) {
        return 'Firefox(火狐)';
    }
    else if (userAgent.indexOf('Opera') !== -1) {
        return 'Opera';
    }
    else if (userAgent.indexOf('Edge') !== -1) {
        return 'Edge';
    }
    else if (userAgent.indexOf('QQ') !== -1 && userAgent.indexOf('QQBrowser') === 1) {
        return '手机QQ';
    }
    else if (userAgent.indexOf('QQBrowser') !== -1) {
        return 'QQ浏览器';
    }
    else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('MetaSr') !== -1) {
        return '搜狗浏览器';
    }
    else if (userAgent.indexOf('MicroMessenger') !== -1) {
        return '微信浏览器';
    }
    else if (userAgent.indexOf('LBBROWSER') !== -1) {
        return '猎豹浏览器';
    }
    else if (userAgent.indexOf('Maxthon') !== -1) {
        return '遨游浏览器';
    }
    else if (userAgent.indexOf('TheWorld') !== -1) {
        return '世界之窗浏览器';
    }
    else if (userAgent.indexOf('bWeibo') !== -1) {
        return '微博';
    }
    else if (userAgent.indexOf('ubrowser') !== -1) {
        return 'UC';
    }
    else if (userAgent.indexOf('bidubrowser') !== -1) {
        return '百度';
    }
    else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
        return 'Safari';
    }
    else if (userAgent.indexOf('Chrome') !== -1) {
        return 'Chrome';
    }
    else {
        return '';
    }
}
var browserType = getBrowserType();

/**
 * 加载JS文件
 * @param {string} url JS路径
 * @returns {Promise<any>} 加载成功的回调
 */
function loadScript(url) {
    return new Promise(function (resolve, reject) {
        var $script = document.createElement('script');
        $script.src = url;
        $script.async = true;
        $script.addEventListener('error', function (e) {
            reject(e);
        });
        $script.addEventListener('load', function () {
            resolve(true);
        });
        document.body.appendChild($script);
    });
}
/**
 * 获取图片的长宽，也可用于校验图片的URL是否有效
 * @param {string} url img的路径
 * @returns {Promise<any>} 有效返回图片宽高，无效返回false
 */
function getImgSize(url) {
    return new Promise(function (resolve) {
        var $img = document.createElement('img');
        $img.src = url;
        $img.style.opacity = '0';
        $img.addEventListener('error', function () {
            document.body.removeChild($img);
            resolve(false);
        });
        $img.addEventListener('load', function () {
            var data = {
                width: $img.naturalWidth,
                height: $img.naturalHeight,
            };
            document.body.removeChild($img);
            resolve(data);
        });
        document.body.appendChild($img);
    });
}
/**
 * 根据给出的文字内容，获取宽度自适应时的宽度
 * @param {string} content 文字内容
 * @param {object} targetDom|styleObj 文字样式继承某dom，或者定制该文字的style
 * @returns {number} number clientWidth 宽度
 */
function getAutoWidth(content, targetDom) {
    var $dom = document.createElement('div');
    $dom.innerHTML = content;
    $dom.style.position = 'absolute';
    $dom.style.opacity = '0';
    $dom.style.padding = '0';
    $dom.style.margin = '0';
    if (targetDom.nodeType) { // 如果是添加到特定的Dom中，继承其字体特性
        ['font-size', 'font-weight', 'border', 'padding'].forEach(function (key) {
            $dom.style.setProperty(key, window.getComputedStyle(targetDom, null).getPropertyValue(key));
        });
    }
    else { // 如果这是个样式对象
        var styleObj = targetDom;
        for (var key in styleObj) {
            $dom.style.setProperty(key, styleObj[key]);
        }
    }
    document.body.appendChild($dom);
    var clientWidth = $dom.clientWidth + 1;
    document.body.removeChild($dom);
    return clientWidth;
}
/**
 * 根据给出的文字内容，获取文字自动换行后的高度
 * @param {string} content 文字内容
 * @param {object} targetDom|styleObj 文字样式继承某dom，或者定制该文字的style
 * @returns {number} clientHeight 高度
 */
function getAutoHeight(content, targetDom) {
    var $dom = document.createElement('div');
    $dom.innerHTML = content;
    $dom.style.position = 'absolute';
    $dom.style.opacity = '0';
    $dom.style.padding = '0';
    $dom.style.margin = '0';
    // console.log(targetDom)
    if (targetDom.nodeType) { // 如果是添加到特定的Dom中，继承其字体特性
        ['font-size', 'font-weight', 'line-height', 'width', 'border', 'padding'].forEach(function (key) {
            $dom.style.setProperty(key, window.getComputedStyle(targetDom, null).getPropertyValue(key));
        });
    }
    else { // 如果这是个样式对象
        var styleObj = targetDom;
        for (var key in styleObj) {
            $dom.style.setProperty(key, styleObj[key]);
        }
    }
    document.body.appendChild($dom);
    var clientHeight = $dom.clientHeight;
    document.body.removeChild($dom);
    return clientHeight;
}
/**
 * 兼容设置页面title
 * @param {string} titleText title文案
 */
function setTitle(titleText) {
    document.title = titleText;
    if (isIOS || isInWeChat) {
        var $iframe = document.createElement('iframe');
        $iframe.title = titleText;
        $iframe.style.opacity = '0';
        document.body.appendChild($iframe);
        document.body.removeChild($iframe);
    }
}
/**
 * 拷贝内容到剪贴板（必须由用户主动触发）
 * @method copyToClipboard
 * @param {string} content 要拷贝的内容
 * @return {Boolean} 拷贝是否成功
 */
function copyToClipboard(content) {
    if (!document.queryCommandSupported('copy')) {
        return false;
    }
    var $input = document.createElement('input');
    $input.style.opacity = '0';
    $input.value = content;
    document.body.appendChild($input);
    $input.select();
    var result = document.execCommand('copy');
    document.body.removeChild($input);
    $input = null;
    return result;
}
/**
 * 根据任意个图片img，合并成一张canvas
 * @param {number} width canvas的长度
 * @param {number} height canvas的高度
 * @param {array} imgDataList img信息，包括img的URL，及该img绘制在canvas中的配置参数，即canvas.drawImage 的参数
 * @returns {Promise<[any]>} 全部图片加载成功且描绘成功后的promise
 */
function createCanvasFromURL(width, height, imgDataList) {
    var promiseLis = [];
    var $canvas = document.createElement('canvas');
    $canvas.width = width;
    $canvas.height = height;
    var _loop_1 = function (i, length_1) {
        var imgItem = imgDataList[i];
        imgItem.config = imgItem.config || [0, 0];
        promiseLis.push(new Promise(function (resolve) {
            var $img = document.createElement('img');
            $img.src = imgItem.url;
            $img.style.opacity = '0';
            $img.addEventListener('error', function () {
                document.body.removeChild($img);
                resolve(false);
            });
            $img.addEventListener('load', function () {
                var _a;
                (_a = $canvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.drawImage.apply(_a, __spreadArray([$img], imgItem.config, false));
                document.body.removeChild($img);
                resolve($canvas);
            });
            document.body.appendChild($img);
        }));
    };
    for (var i = 0, length_1 = imgDataList.length; i < length_1; i++) {
        _loop_1(i);
    }
    return Promise.all(promiseLis);
}
/**
 * 获取当前光标偏移值
 * @returns {number} 当前光标偏移值
 */
function getCursorOffset() {
    var selectObj = getSelection(); // 获取选中对象
    if (selectObj && selectObj.rangeCount > 0) { // 如果有选择范围
        var selectRange = selectObj.getRangeAt(0); // 获取选中对象的第一个选择范围
        return selectRange.startOffset; // 记录选项开始位置
    }
    return -1;
}
/**
 * 设置光标位置
 * @param {object} dom 光标所在dom节点
 * @param {number} offset 光标偏移值
 */
function setCursorOffset(dom, offset) {
    var selectObj = getSelection(); // 获取选中对象
    var selectRange = selectObj === null || selectObj === void 0 ? void 0 : selectObj.getRangeAt(0); // 获取选中对象的第一个选择范围
    selectRange === null || selectRange === void 0 ? void 0 : selectRange.setStart(dom, offset); // 设置光标位置
    selectRange === null || selectRange === void 0 ? void 0 : selectRange.collapse(true); // 光标开始和光标结束重叠
    selectObj === null || selectObj === void 0 ? void 0 : selectObj.removeAllRanges(); // 清除选定对象的所有光标对象
    selectRange && (selectObj === null || selectObj === void 0 ? void 0 : selectObj.addRange(selectRange)); // 插入新的光标对象
}
/**
 * 设置光标位于某元素后面
 * @param {object} dom 光标所在dom节点
 */
function setCursorAfter(dom) {
    var selectObj = getSelection(); // 获取选中对象
    var selectRange = document.createRange();
    selectRange.setStartAfter(dom);
    selectRange.collapse(true); // 光标开始和光标结束重叠
    selectObj === null || selectObj === void 0 ? void 0 : selectObj.removeAllRanges(); // 清除选定对象的所有光标对象
    selectObj === null || selectObj === void 0 ? void 0 : selectObj.addRange(selectRange); // 插入新的光标对象
}
/**
 * 判断是否支持某CSS样式
 * @param {string} attr 样式名
 * @param {string} value 样式值
 * @returns {boolean} 是否支持某CSS样式
 */
function cssSupport(attr, value) {
    var styleValue = String(value);
    var element = document.createElement('div');
    if (attr in element.style) {
        element.style.setProperty(attr, styleValue);
        return element.style.getPropertyValue(attr) === styleValue;
    }
    else {
        return false;
    }
}
/**
 * 容器滚动函数
 * @param {string} $target 需要滚动的目标dom
 * @param {number} space 滚动距离
 * @param {number} time 分多少次执行完成
 * @param {function} endHandler 执行完成回调
 */
// eslint-disable-next-line
function scrollTo($target, space, time, endHandler) {
    if (time === void 0) { time = 30; }
    var requestAnimFrame = (function () { return window.requestAnimationFrame
        || window.webkitRequestAnimationFrame
        || window.mozRequestAnimationFrame
        || function (callback) {
            window.setTimeout(callback, 1000 / 60);
        }; })();
    var eachSpace = space / time; // 单次滚动的距离
    function move(moveSpace, remainTime) {
        requestAnimFrame(function () {
            remainTime--;
            $target.scrollTop += moveSpace;
            if (remainTime <= 0) {
                if (endHandler && typeof endHandler === 'function') {
                    endHandler();
                }
            }
            remainTime > 0 && move(moveSpace, remainTime);
        });
    }
    move(eachSpace, time);
}

// 封装 localStorage 逻辑
var Storage = /** @class */ (function () {
    /**
     * 生成存储对象的构造函数
     * @param {string} key localStorage 中的 key 值
     * @param {dataType} type 数据类型，如 Object
     * @param {any} fallback 解析失败时返回的默认值
     */
    function Storage(key, type, fallback) {
        this.key = key;
        this.type = type; // 将第一个字母转为大写
        this.fallback = fallback;
    }
    /**
     * 获取 localStorage 中的数据，不存在则返回 fallback 的值或 null
     * @returns {string|null} localStorage 中的数据
     */
    Storage.prototype.get = function () {
        var localStorageStr = window.localStorage.getItem(this.key); // 对象 json
        if (localStorageStr === 'undefined') {
            // 如果获取到的值是 undefined，则返回 undefined
            return undefined;
        }
        else if (localStorageStr !== null) {
            try {
                var result = JSON.parse(localStorageStr);
                if (!this.type) {
                    return result;
                }
                else if (Object.prototype.toString.call(result) === "[object ".concat(this.type, "]")) {
                    return result;
                }
            }
            catch (err) {
                if (err instanceof Error) {
                    // eslint-disable-next-line no-console
                    console.error("\u5B57\u7B26\u4E32 ".concat(localStorageStr, " \u89E3\u6790\u5931\u8D25: ").concat(err.message));
                }
                else {
                    // eslint-disable-next-line no-console
                    console.error("\u5B57\u7B26\u4E32 ".concat(localStorageStr, " \u89E3\u6790\u5931\u8D25"));
                    // eslint-disable-next-line no-console
                    console.error(err);
                }
            }
        }
        if (typeof this.fallback === 'undefined') {
            // 如果 localStorage 中不存在该值，则返回 null
            return null;
        }
        else if (typeof this.fallback === 'function') {
            return this.fallback(localStorageStr);
        }
        return this.fallback;
    };
    /**
     * 将数据存储到 localStorage 中
     * @param {any} value 需要保存到 localStorage 的数据
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
    Storage.prototype.set = function (value) {
        if (typeof value === 'function') {
            var oldValue = this.get();
            var newValue = value(oldValue);
            // 传入函数时，表示直接获取上次保存的值，修改后再存入
            this.set(newValue);
        }
        var type = Object.prototype.toString.call(value);
        if (this.type && type !== "[object ".concat(this.type, "]")) {
            var matchedType = type.replace(/^\[object (\S+)\]$/, '$1');
            throw new Error("".concat(this.key, " \u7C7B\u578B\u4E0D\u5339\u914D\uFF0C\u671F\u5F85\u7C7B\u578B\uFF1A").concat(this.type, "\uFF0C\u4F20\u5165\u7684\u7C7B\u578B\uFF1A").concat(matchedType));
        }
        window.localStorage.setItem(this.key, JSON.stringify(value));
    };
    /**
     * 删除key对应的数据
     */
    Storage.prototype.remove = function () {
        window.localStorage.removeItem(this.key);
    };
    /**
     * 获取 localStorage 中的数据，不存在则返回 fallback 的值或 null
     * @param {string} key localStorage 中的 key 值
     * @param {dataType} type 数据类型，如 Object
     * @param {any} fallback 解析失败时返回的默认值
     * @returns {string|null} localStorage 中的数据
     */
    Storage.get = function (key, type, fallback) {
        var storage = new Storage(key, type, fallback);
        return storage.get();
    };
    /**
     * 将数据存储到 localStorage 中
     * @param {string} key localStorage 中的 key 值
     * @param {any} value 需要保存到 localStorage 的数据
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
    Storage.set = function (key, value) {
        var storage = new Storage(key);
        storage.set(value);
    };
    /**
     * 删除key对应的数据
     * @param {string} key 保存数据的键
     */
    Storage.remove = function (key) {
        var storage = new Storage(key);
        storage.remove();
    };
    return Storage;
}());

export { Storage, addClass, afterMonths, base64ToFile, blobToBuffer, browserType, changeObjKey, compareFillZero, copyToClipboard, createCanvasFromURL, cssSupport, dataType, dealTime, debounce, deleteEmpty, download, downloadFile, fillZero, formatCountDown, formatDuration, formatSize, formatTime, getAutoHeight, getAutoWidth, getBase64Image, getCamelCase, getCursorOffset, getDateSpace, getDateTips, getDayRange, getDecimalsLength, getElementLeft, getElementTop, getFileName, getFitURL, getImgSize, getLastSomeDay, getMatchObj, getMatchObjIndex, getMatchObjList, getMonthDays, getMonthRange, getParams, getPath, getScrollTop, getStyle, getSuffix, getTimeLength, getURL, getUnderScoreCase, getWeek, getWeekRange, getWord, inTimeRange, isAndroid, isContainIn, isHuaweiBrowser, isIOS, isInApp, isInQQ, isInQQBrowser, isInWeChat, isInWeibo, isMiBrowser, isMobile, isMoney, isNotVoid, isOverdue, isPassword, isPhone, isSame, isServer, isTheDayAfterTomorrow, isTheDayBeforeYesterday, isToday, isTomorrow, isYesterday, keep2Decimals, loadScript, openWindow, paramObjToQueryString, parseNum, parseObjStr, randomString, removeClass, scrollTo, scrollToTop, serialize, setCursorAfter, setCursorOffset, setTitle, smoothScroll, validateEmail, validateIDNumber, wan2yuan, yuan2fen, yuan2wan };
